import React from 'react'
import style from "../DashBoardLayout/styles/Footer.module.css"
const Footer = () => {
  return (
    <div className={style.footer}>
    @ Copyright KFintech | All Rights Reserved
    </div>
  )
}

export default Footer